import { html } from 'lit-html';
import { each, If } from '../../../component';
import { getAssetsUrlBase } from '../../../models/common/static_resource_util';
import { CouponModalJsEnv } from '../../../models/coupon/coupon_modal_js_env';
import { Coupon } from '../../../models/coupon/coupon_information';

export const CouponModalContentsBody = (model: CouponModalJsEnv) => {
  const options = {
    catalogItemCode: model.catalogItemCode
  };

  return html`
    ${model.shouldShowModal
      ? each(model.coupons, CouponModalContentsDetailBody, options)
      : ErrorBody()}
  `;
};

export const CouponModalContentsDetailBody = (
  coupon: Coupon,
  _index: number,
  _items: Coupon[],
  options: {
    [key: string]: string;
  }
) => {
  return html`
    <div class="a-box -bordered u-mb-16">
      <div class="o-colBox -aistart -margin24 -growChild2">
        <a href="${coupon.ftrUrl}" class="a-img -static">
          <span class="a-img_imgWrap">
            <img
              class="a-img_img js-lazy-img"
              data-src="${coupon.cpnImagePath}"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mN89h8AAtEB5wrzxXEAAAAASUVORK5CYII="
              alt="${coupon.cpnName}"
              width="97"
              height="97"
            />
          </span>
        </a>
        <div class="a-colitem">
          ${BundleDiscountCouponLabelBody(coupon, options.catalogItemCode)}
          <p class="a-text -large u-mb-16">
            <a href="${coupon.ftrUrl}" class="a-textlink">${coupon.cpnName}</a>
          </p>
          <p class="a-text -medium u-mb-16">${DiscountRateBody(coupon)}</p>
          <div class="o-colBox -jcbetween -aistretch -margin16 -noShrinkChild2">
            <div class="a-colitem">
              <dl class="a-dl -dtNowrap">
                <dt>有効期限</dt>
                <dd>${coupon.limitTermFrom}〜${coupon.limitTermTo}</dd>
              </dl>
              ${DiscountConditionBody(coupon)}
            </div>
            <div class="o-colBox -aiend" style="width:142px">
              <a href="${coupon.ftrUrl}" class="m-btn -tertiary">
                <span class="m-btn_inner"><span class="m-btn_text">対象商品を確認</span></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
};

export const BundleDiscountCouponLabelBody = (coupon: Coupon, catalogItemCode: string) => {
  const targetCatalogItem = coupon.ctgItemCdList.find(
    (ctgItem) => ctgItem.ctgItemCd === catalogItemCode
  );

  const isOffNotTarget =
    targetCatalogItem !== undefined && targetCatalogItem.offNotTargetFlg === '1';

  const bundleDiscountCouponLabelHtml = html`
    ${isOffNotTarget
      ? html`
          <span class="a-tag -bgSetCoupon u-mb-12">
            <span class="o-colBox">
              まとめ割<span class="a-span u-text-normal u-text-10">（値引き対象外）</span>
            </span>
          </span>
        `
      : html`<span class="a-tag -bgSetCoupon u-mb-12">まとめ割</span>`}
  `;

  return html` ${If(coupon.isBundleDiscountCoupon(), bundleDiscountCouponLabelHtml)} `;
};

export const DiscountRateBody = (coupon: Coupon) => {
  const isShowMinOffRate = !isEmpty(coupon.minOffRate) && coupon.offRate !== coupon.minOffRate;

  let discountRateStr = '';
  if (coupon.offTarget === '1') {
    discountRateStr = 'レジ';
  } else if (coupon.offTarget === '2' || coupon.isBundleDiscountCoupon()) {
    discountRateStr = '対象商品';
  }

  return html`
    ${discountRateStr}の合計金額（税込）から${If(
      isShowMinOffRate,
      html`${coupon.minOffRate}％～`
    )}${coupon.offRate}％OFF
  `;
};

export const DiscountConditionBody = (coupon: Coupon) => {
  const isShowDiscountCondition =
    coupon.isBundleDiscountCoupon() ||
    (!isEmpty(coupon.lowerLimitPrice) && coupon.lowerLimitPrice !== '0');

  let offTargetStr = '';
  if (coupon.lowerLimitKbn === '1') {
    offTargetStr = 'レジ';
  } else if (coupon.lowerLimitKbn === '2') {
    offTargetStr = '対象商品';
  }

  const discountConditionHtml = html`
    <dl class="a-dl -dtNowrap u-mt-12">
      <dt>ご利用条件</dt>
      <dd>
        ${coupon.isBundleDiscountCoupon()
          ? '対象商品のうち購入する商品のカテゴリー数によって割引率が変わります。'
          : html`
              ${offTargetStr}の合計金額（税込）が、${coupon.lowerLimitPriceCommaSeparate()}円以上の場合にご利用いただけます。
            `}
      </dd>
    </dl>
  `;

  return If(isShowDiscountCondition, discountConditionHtml);
};

export const ErrorBody = () => {
  return html`
    <div class="a-box -warning u-mb-16">
      <div class="m-information -warning">
        <p class="m-information_hdg">
          <span class="m-information_hdgicon">
            <span class="a-icon -size24">
              <img
                class="a-icon_img"
                src="${getAssetsUrlBase()}images/icon_information_red.svg"
                alt=""
                width="24"
                height="24"
              />
            </span>
          </span>
          <span class="m-information_hdgmain">
            <span class="m-information_hdgmain_text">
              予期せぬエラーが発生しました。もう一度お試しください。
            </span>
          </span>
        </p>
      </div>
    </div>
  `;
};

const isEmpty = (value: string): boolean => {
  return value === undefined || value === null || value === '';
};
